import storageWeb from "redux-persist/lib/storage";
export default storageWeb;
